const actionMap = {
  Campaign: ['campaigns/update', 'CampaignsGrid'],
  AdGroup: ['adgroup/update', 'AdGroupGrid'],
  Ad: ['ads/update', 'AdGrid'],
  Keyword: ['keyword/update', 'KeywordGrid'],
  NegativeKeywordList: ['NegativeKeywordLibraryCampaignAssociationsGrid'],
  CampaignCriterion: ['campaignssettings/update', 'CampaignSettingsGrid'],
  AdGroupCriterion: ['campaignssettings/update', 'AdGroupSettingsGrid'],
};
const resourceMap = {
  CampaignsGrid: 'Campaign',
  AdGroupGrid: 'AdGroup',
  AdGrid: 'Ad',
  KeywordGrid: 'Keyword',
  NegativeKeywordLibraryCampaignAssociationsGrid: 'NegativeKeywordList',
  CampaignSettingsGrid: 'CampaignCriterion',
  AdGroupSettingsGrid: 'AdGroupCriterion',
  PerformanceTargetsSummaryGrid: 'PerformanceTarget',
  SearchTermGrid: 'SearchTerm',
  DsaTargetGrid: 'DsaTarget',
  NegativeAdGroupDsaTargetGrid: 'NegativeAdGroupDsaTarget',
  NegativeCampaignDsaTargetGrid: 'NegativeCampaignDsaTarget',
};

export class ContextManagerBridge {
  constructor({
    cacheManager,
    contextManager,
  }) {
    // Use the dirty flags to prevent duplicated invalidation
    const cacheManagerDirty = {};
    const contextManagerDirty = {};

    // Hook up cache manager, subscribe the notifications
    cacheManager.subscribe({

      // Clear the context manager after invalidate
      afterInvalidate(cm, resource) {
        const gridIds = actionMap[resource];

        delete cacheManagerDirty[resource];

        if (gridIds && contextManagerDirty[resource]) {
          contextManager.updateContext(gridIds);
        }
      },

      // Mark the dirty flags before execution of 'findAll'
      beforeExecute(cm, { action, parameters }) {
        if (action === 'findAll') {
          const { name: resource } = parameters[0];
          cacheManagerDirty[resource] = true;
          contextManagerDirty[resource] = true;
        }
      },
    });

    // Hook up context manager, patch the updateContext method
    const { emitter } = contextManager;

    emitter.on('invalidate', (gridId) => {
      const resource = resourceMap[gridId];

      if (resource) {
        delete contextManagerDirty[resource];
        if (cacheManagerDirty[resource]) {
          cacheManager.invalidate(resource, true);
        }
      }
    });
  }
}
